import api from "./BaseServices";
import { transactionStatusEnum } from "../enums/transactionStatusEnum";
import { shippingStatusEnum } from "../enums/shippingStatusEnum";

const API_URL = `${process.env.REACT_APP_API_URL}/transactions`;

export interface TransactionData {
  id?: number;
  user_id: number;
  amount: number;
  transaction_type: string;
  status: string;
  comment: string;
  created_at: Date;
}

export interface TransactionBoosterData {
  transactions_id: number;
  booster_id: number;
  is_opened: boolean;
}

export interface TransactionCardData {
  transactions_id: number;
  booster_id: number;
  is_opened: boolean;
}

export interface StoreTransactionsData {
  id: number;
  status: transactionStatusEnum;
  created_at: Date;
  updated_at: Date;
  booster_id: string;
  quantity: number;
  name: string;
  image_id: string;
  price: number;
  description: string;
  net_amount: number;
  comment?: string;
  shipping_status?: shippingStatusEnum;
}

export interface printTransactionData extends StoreTransactionsData {
  shipping_status: shippingStatusEnum;
}

export const getAllUnopenedBoosters = async (): Promise<string[]> => {
  const response = await api.get(`${API_URL}/unopened-boosters`);
  return response.data;
};

export const getAllTransactions = async (): Promise<
  (StoreTransactionsData & { type: string })[]
> => {
  const response = await api.get(`${API_URL}`);
  return response.data;
};

//sellers

export const getStoreTransactions = async (
  month: number,
  year: number
): Promise<(StoreTransactionsData & { type: string })[]> => {
  const response = await api.get(`${API_URL}/store`, {
    params: {
      month: month,
      year: year,
    },
  });
  return response.data;
};

export const getTransferableAmount = async (): Promise<number> => {
  const response = await api.get(`${API_URL}/transfer/amount`);
  return response.data.amount;
};

export const refundBoosterTransaction = async (
  transactionId: number,
  boosterId: string,
  comment: string
): Promise<boolean> => {
  const response = await api.post(
    `${API_URL}/${transactionId}/boosters/${boosterId}/refund`,
    { comment }
  );

  return response.data;
};

export const refundPrintTransaction = async (
  transactionId: number,
  boosterId: string,
  comment: string
): Promise<boolean> => {
  const response = await api.post(
    `${API_URL}/${transactionId}/prints/${boosterId}/refund`,
    { comment }
  );

  return response.data;
};

export const getInvoice = async (transactionId: number): Promise<string> => {
  const response = await api.get(`${API_URL}/${transactionId}/invoice`);
  return response.data;
};
